import './Contato.css'
import Header from '../../componentes/js/Header';
import Footer from '../../componentes/js/Footer';
import { useEffect, useState } from 'react';

const Contato = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent)) {
      setIsMobile(true);
    }
  }, []);

  return (
    <div style={{backgroundImage: 'url(assets/images/fundo/fundo2.png)', backgroundSize: isMobile ? '60%' : '25%', backgroundPosition: 'center', backgroundRepeat: 'repeat', marginBottom: '-16vh'}}>
      <Header />
      <main>
      <div className="containerContato">
        <div className='tituloContato'>
          <h1 style={{ marginTop: 10 + 'px'}}>Contato</h1>
        </div>
        {/* Atalhos de contato: só aparecem no celular (ver estilos/mobile.css) */}
        <div className="contato-rapido">
          <p>
            <strong>Colégio Líder</strong><br />
            Rua José da Cunha, Quadra 126, Lotes 19/24<br />
            St. dos Afonsos, Aparecida de Goiânia - GO
          </p>
          <div className="contato-rapido-botoes">
            <a className="whats" href="https://wa.me/5562998271550" target="_blank" rel="noreferrer">Conversar no WhatsApp</a>
            <a href="tel:+556235480070">Ligar: (62) 3548-0070</a>
            <a className="rota" href="https://www.google.com/maps/search/?api=1&query=Col%C3%A9gio+L%C3%ADder+Aparecida+de+Goi%C3%A2nia" target="_blank" rel="noreferrer">Como chegar (abrir no mapa)</a>
          </div>
        </div>
        <article>
          <div className="map-container">
            <h2>Como Chegar</h2>
            <iframe 
              title='Mapa de localização do Colégio Líder'
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2271.856732514448!2d-49.2689922284222!3d-16.737208849927573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935ef0beaeb330ad%3A0x36994ee1ea372394!2zQ29sw6lnaW8gTMOtZGVyIEdP!5e0!3m2!1spt-BR!2sbr!4v1718672574335!5m2!1spt-BR!2sbr"
              width="600" height="562" style={{ border: 0 }} allowFullScreen="" loading="lazy"
            ></iframe>
          </div>
        </article>
      </div>
      </main>
      <Footer />
    </div>
  );
};

export default Contato;
